const routes = [
  {
    path: 'starrysky',
    name: 'starrysky',
    component: () => import(/* webpackChunkName: "starrysky" */ '@/modules/starrysky/index.vue')
  },
];

export default routes;